import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  undefined
>("courses.enrollments.request");

export const request = {
  ...postApis,
};
